export class PlatformModel {
    public static isMac: boolean;
    public static isSafari: boolean;
    public static isFirefox: boolean;
}